import { getConfig } from '@b2ag/micro-front-tools'
import UsagesService from './services/usages.service'

const usagesApiHost = getConfig('USAGES_API_HOST')

const usagesService = new UsagesService({ usagesApiHost })

export { usagesService }
